import { SAVE_LANG } from "constants/LocalizationTypes";

export function saveLang(lang) {
  return {
    type: SAVE_LANG,
    lang,
  };
}
